import React, { useState } from "react";

import
  PropTypes
from 'prop-types';

import {
  DetailsSection,
  MainDetailsSection
 } from '../MainSection.styles'

import { PopUp } from "../popUp";
import { LoginLayout } from './LoginLayout';
import { NotificationAlerts } from "../notificationAlerts/notificationAlerts";

export const LoginAuth = (props) => {
  
  const [ viewPopup, setViewPopup ] = useState('flex');
  const [ refDetails, setRefDetails ] = useState({});
  const [ accountType, setAccountType ] = useState('');
  const [ isSuccess, setIsSuccess ] = useState();
  const [ notificationAlertDisplay, setNotificationAlertDisplay ] = useState('');
  const [ notificationAlertMessage, setNotificationAlertMessage ] = useState('');

  return (
    <>
    { notificationAlertDisplay &&
      <NotificationAlerts
        display={notificationAlertDisplay}
        setDisplay={setNotificationAlertDisplay}
        notificationText={notificationAlertMessage}
      />
    }
    {
      isSuccess &&
      <PopUp
        viewPopup={viewPopup}
        setViewPopup={setViewPopup}
        refDetails={refDetails}
        setRefDetails={setRefDetails}
        accountType={accountType}
        setAccountType={setAccountType}
      />
    }
    <MainDetailsSection>


      <DetailsSection>
        <LoginLayout
          setAccountType={props.pageToBeDisplayed}
          showCloseBtn={props.showCloseBtn}
          isError={props.isError}
          callFromChildPage={props.callFromChildPage}
          showLoader={props.showLoader}
          setPassword={props.setPassword}
          notificationAlertDisplay={notificationAlertDisplay}
          setNotificationAlertDisplay={setNotificationAlertDisplay}
          notificationText={notificationAlertMessage}
          setNotificationText={setNotificationAlertMessage}
        />
      </DetailsSection>
    </MainDetailsSection>
    </>
  );
};

LoginAuth.propTypes = {
  setAccountType: PropTypes.func,
  showCloseBtn: PropTypes.func,
  isError: PropTypes.bool,
  callFromChildPage: PropTypes.func,
  showLoader: PropTypes.func,
  setPassword: PropTypes.func,
};

LoginAuth.defaultProps = {
  setAccountType: ()=>{},
  showCloseBtn: ()=>{},
  isError: false,
  callFromChildPage: ()=>{},
  showLoader: ()=>{},
  setPassword: ()=>{},
};
